import AppConstants from '../../AppConstants';
import { downloadFileFromURL } from '../../utils/utils';
import {
  FETCH_UPLOAD_HISTORY,
  DOWNLOAD_EXCEL,
  UPLOAD_HISTORY_SET_ROWS_PER_PAGE,
  UPLOAD_HISTORY_SET_PAGE,
  FETCH_UPLOAD_REPORT,
  VIEW_REPORT_SET_ROWS_PER_PAGE,
  VIEW_REPORT_SET_PAGE,
} from '../action-types/upload-history-types';

const initialState = {
  paginationConfig: {
    total: 0,
    page: 1,
    rowsPerPage: AppConstants.rowsPerPage,
  },
  viewReportPaginationConfig: {
    total: 0,
    page: 1,
    rowsPerPage: AppConstants.rowsPerPage,
  },
  loading: false,
  history: [],
  report: [],
};

export default function UploadHistoryReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_UPLOAD_HISTORY.REQUEST:
      return {
        ...state,
        loading: true,
        history: [],
      };
    case FETCH_UPLOAD_REPORT.REQUEST:
      return {
        ...state,
        loading: true,
        report: [],
      };
    case FETCH_UPLOAD_HISTORY.SUCCESS:
      return {
        ...state,
        loading: false,
        history: action.payload.data.historyRecords,
        paginationConfig: {
          ...state.paginationConfig,
          total: action?.payload?.data?.pagination?.total,
        },
      };
    case FETCH_UPLOAD_REPORT.SUCCESS:
      return {
        ...state,
        loading: false,
        report: action?.payload?.data?.historyRecords,
        viewReportPaginationConfig: {
          ...state.viewReportPaginationConfig,
          total: action?.payload?.data?.pagination?.total,
        },
      };
    case FETCH_UPLOAD_HISTORY.REJECTED:
      return {
        ...initialState,
        loading: false,
        error: action?.payload?.data,
      };
    case FETCH_UPLOAD_REPORT.REJECTED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.data,
      };
    case UPLOAD_HISTORY_SET_ROWS_PER_PAGE:
      return {
        ...state,
        paginationConfig: {
          ...state.paginationConfig,
          rowsPerPage: action.payload,
        },
      };
    case VIEW_REPORT_SET_ROWS_PER_PAGE:
      return {
        ...state,
        viewReportPaginationConfig: {
          ...state.viewReportPaginationConfig,
          rowsPerPage: action.payload,
        },
      };
    case UPLOAD_HISTORY_SET_PAGE:
      return {
        ...state,
        paginationConfig: {
          ...state.paginationConfig,
          page: action.payload,
        },
      };
    case VIEW_REPORT_SET_PAGE:
      return {
        ...state,
        viewReportPaginationConfig: {
          ...state.viewReportPaginationConfig,
          page: action.payload,
        },
      };
    case DOWNLOAD_EXCEL.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DOWNLOAD_EXCEL.SUCCESS: {
      downloadFileFromURL(
        action.payload.data?.result?.url,
        'View_History_File',
      );
      return {
        ...state,
        loading: false,
      };
    }
    case DOWNLOAD_EXCEL.REJECTED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
